import PropTypes from "prop-types";
import { Grid } from "@mui/material";

import { FilterWrapper, FilterSortSubtitle, StyleButton } from "../../styles";

const ContentTypes = ({ onFilterClick, contentTypes, selectedContentTypes }) => {
  return (
    <FilterWrapper>
      <FilterSortSubtitle>Content Types</FilterSortSubtitle>
      <Grid container spacing="7px">
        {contentTypes.map((item) => (
          <Grid item xs={6} key={`content-type-${item.key}`}>
            <StyleButton
              fullWidth
              variant="outlined"
              className={selectedContentTypes.includes(item.key) ? "selected" : ""}
              onClick={() => onFilterClick(item)}
            >
              {item.label}
            </StyleButton>
          </Grid>
        ))}
      </Grid>
    </FilterWrapper>
  );
};

ContentTypes.propTypes = {
  onFilterClick: PropTypes.func.isRequired,
  selectedContentTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  contentTypes: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      value: PropTypes.arrayOf(PropTypes.string).isRequired,
    }),
  ).isRequired,
};

export default ContentTypes;
